import { render, staticRenderFns } from "./PurchaseEdit.vue?vue&type=template&id=e6390250&scoped=true&"
import script from "./PurchaseEdit.vue?vue&type=script&lang=js&"
export * from "./PurchaseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6390250",
  null
  
)

export default component.exports